<div class="cdw-export-for-bulk-edit-dialog" data-testid="export-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">Export for Bulk Edit</h2>
    <button
      type="button"
      class="dialog-close-button"
      (click)="onCancel()"
      aria-label="Close dialog"
    >
      <lib-cdw-icon icon="close"></lib-cdw-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="dialog-content" [formGroup]="exportForm">
    <h3 class="section-title">Export Device Information</h3>
    <div class="section-divider"></div>

    <p class="section-description">
      Table header content and Device ID must match for successful file import. To ensure the best results, export existing data, make the desired corrections, and upload the edited file.
      <a
        class="cross-link"
        (click)="onReturnToImport()"
        data-testid="export-dialog-return-to-import-link"
        >Return to Import Device</a
      >
    </p>

    <div class="info-banner">
      <lib-cdw-icon icon="info" [outlined]="true"></lib-cdw-icon>
      <span>Gopher Device ID must be included for each row to map correctly.</span>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>File Name</mat-label>
      <input matInput formControlName="fileName" />
      <mat-error *ngIf="exportForm.get('fileName')?.hasError('invalidFileName')">
        File name must be under 100 characters and cannot contain \ / : * ? " &lt; &gt; |
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Rows to export</mat-label>
      <mat-select formControlName="scope" data-testid="export-dialog-scope-select">
        <mat-option
          *ngFor="let opt of scopeOptions"
          [value]="opt.value"
          [disabled]="opt.disabled"
        >
          <span
            [matTooltip]="opt.tooltip || ''"
            [matTooltipDisabled]="!opt.tooltip"
            class="option-label"
          >{{ opt.label }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Export format</mat-label>
      <mat-select formControlName="format" data-testid="export-dialog-format-select">
        <mat-option
          *ngFor="let opt of formatOptions"
          [value]="opt.value"
          [disabled]="opt.disabled"
        >
          <span
            [matTooltip]="opt.tooltip || ''"
            [matTooltipDisabled]="!opt.tooltip"
            class="option-label"
          >{{ opt.label }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="cellCountWarning" class="cell-count-warning" [class.exceeded]="cellCountExceeded">
      <lib-cdw-icon [icon]="cellCountExceeded ? 'error' : 'warning'"></lib-cdw-icon>
      <span>{{ cellCountWarning }}</span>
    </div>
  </div>

  <!-- Actions -->
  <div class="dialog-actions">
    <lib-cdw-button
      (buttonClick)="onCancel()"
      level="secondary"
      mode="standard"
    >
      Cancel
    </lib-cdw-button>
    <lib-cdw-button
      (buttonClick)="onExport()"
      level="primary"
      mode="standard"
      [disabled]="exportForm.invalid || isSubmitting || cellCountExceeded"
      data-testid="export-dialog-export-button"
    >
      {{ isSubmitting ? 'Exporting...' : 'Export Current View' }}
    </lib-cdw-button>
  </div>
</div>
